import { Component, OnDestroy, OnInit } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { ToastService } from '../../services/toast.service';
import { Subscription } from 'rxjs';
import { InvoiceHistoryService } from '../../services/invoice-history.service';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { WebOrderDto } from '../../Model/web-order-dto';
import { CommonExternalModule } from '../../common/common-external-module';
import { MatTableDataSource } from '@angular/material/table';
import { DeliveryFeedBack } from '../../Model/delivery-feed-back';
import moment from 'moment';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ProductService } from '../../services/product.service';
import { HeaderComponent } from '../../components/header/header.component';
import { InvoicePreviewComponent } from '../../dialog/invoice-preview/invoice-preview.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-order-history',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent],
  templateUrl: './order-history.component.html',
  styleUrl: './order-history.component.css'
})
export class OrderHistoryComponent implements OnInit, OnDestroy {

  currentUrl: string;
  length: number;

  googleCustomer: GoogleCustomer;
  dataSource: MatTableDataSource<WebOrderDto>;
  viewWebChildTab: WebOrderDto[] = [];
  viewWebChildTabList: WebOrderDto[] = [];
  // Default statusList
  readonly statusList: string[] = ['Order Placed', 'Accepted', 'In Process', 'Production Done', 'Rider assigned', 'Out for Delivery', 'Delivered'];
  locationRateValue = new UntypedFormControl(null, Validators.required);
  deliveryRateValue = new UntypedFormControl(null, Validators.required);
  isLocationFeedBackDone: boolean = false;
  isDeliveryFeedBackDone: boolean = false;

  private onViewSetUpSubscription: Subscription;
  private insertFeedBackDeliveryBoy: Subscription;
  private insertFeedBackLocation: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    // private formBuilder: UntypedFormBuilder,
    private apiFactory: ApiFactoryEndPoints,
    private toastService: ToastService,
    public dialog: MatDialog,
    private invoiceHistoryService: InvoiceHistoryService,
    // private productOrderSummaryService: ProductOrderSummaryService,
    public productService: ProductService
  ) {
    this.dataSource = new MatTableDataSource(this.viewWebChildTab);
    this.dataSource.filterPredicate = (data: any, filter) => {
      let dataStr = JSON.stringify(data).toLowerCase();
      return dataStr.indexOf(filter) != -1;
    };
  }

  ngOnInit() {
    this.currentUrl = window.location.host.replace(':', '');
    // this.pageSize = this.pageSizeCommon;
    this.viewWebOrderHistory();
  }

  ngOnDestroy(): void {

  }

  viewWebOrderHistory() {
    // Retrieve logged-in customer details
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));

    // Determine customer email
    const customerEmail = this.googleCustomer?.email;
    if (!customerEmail) {
      this.toastService.showErrorToast("No user logged in");
      return;
    }

    // Fetch order history
    this.onViewSetUpSubscription = this.invoiceHistoryService.getWebOrderDetailsByLoggedInUser(this.apiFactory.getWebOrderDetailsByLoggedInUser, customerEmail, this.currentUrl)
      .subscribe((data: any) => {
        if (!data || data.length === 0) {
          this.toastService.showErrorToast("No Data Available");
          return;
        }

        // Assign data to required properties
        this.dataSource.data = data;
        this.length = data.totalElements;
        this.viewWebChildTabList = data;
        this.viewWebChildTab = [...data];

        // Process each order
        data.forEach((order: WebOrderDto) => {
          order.isShippingCharge = order.webOrderDetails.some(e => e.productName === 'Shipping Charge');
          this.setStatusListOnData(order);
        });

        console.log(data);
      });
  }

  setStatusListOnData(element: WebOrderDto) {
    element.statusList = [];

    // Determine initial invStatus
    let invStatus: string = element.currentStatus === 'Confirmed' ? 'Order Placed' : element.currentStatus === 'Declined' ? 'Cancelled'
      : (element.invoiceDetails[0].invoiceType !== 'Make To Order' && element.invoiceDetails[0].invStatus !== 'Cancelled' && !element.assignShippingDto)
        || (!element.assignShippingDto && ['Billed', 'Received'].includes(element.invoiceDetails[0].invStatus))
        ? 'Confirmed' : element.assignShippingDto && ['Billed', 'Received'].includes(element.invoiceDetails[0].invStatus)
          ? 'Confirmed' : element.invoiceDetails[0]?.invStatus;

    // Determine trackingStatus
    let status: string = (invStatus == 'Confirmed' || invStatus == 'Ordered' || invStatus == 'Declined' || element.currentStatus == 'Accepted') && element.assignShippingDto == null && !element.deliveryStatus ? 'Accepted'
      : invStatus == 'Confirmed' && (element.assignShippingDto?.status == 'Assigned' || element.assignShippingDto?.status == 'Re-Assigned' || element.assignShippingDto?.status == 'Rider Declined' || element.assignShippingDto?.status == 'Pick-Up-Cancelled' || element.assignShippingDto?.status == 'Ready To Ship') ? 'Received at location'
        : invStatus == 'Confirmed' && (element.assignShippingDto?.status == 'Rider Accepted') ? 'Rider assigned'
          : invStatus == 'Confirmed' && element.assignShippingDto?.status == 'Picked-Up' ? 'Out for Delivery'
            : invStatus == 'Confirmed' && element.assignShippingDto?.status == 'Delivered' ? 'Delivered'
              : invStatus == 'Confirmed' && element.assignShippingDto?.status == 'Re-Scheduled' ? 'Rescheduled'
                : invStatus == 'Confirmed' && element.assignShippingDto?.status == 'Delivery Cancelled' ? 'Cancelled'
                  // : invStatus == 'Dispatched' && element.assignShippingDto == null ? 'Dispatched to location'
                  : invStatus == 'Cancelled' && element.assignShippingDto == null ? 'Order Cancelled'
                    : invStatus != 'Confirmed' && invStatus != 'Ordered' ? invStatus
                      // : invStatus == 'Confirmed' && element.dispatchStorePickupDto?.status == 'Dispatched' ? 'Dispatched to location'
                      //   : invStatus == 'Confirmed' && element.dispatchStorePickupDto?.status == 'Received' ? 'Received at location'
                      : invStatus == 'Confirmed' && element.assignShippingDto == null && element.deliveryStatus == 'Delivered' ? 'Delivered'
                        // : invStatus == 'Confirmed' && element.dispatchStorePickupDto?.status == 'Return' ? 'Returned'
                        //   : invStatus == 'Confirmed' && element.dispatchStorePickupDto?.status == 'Return Received' ? 'Returned'
                        //     : invStatus == 'Confirmed' && element.dispatchStorePickupDto?.status == 'Delivered' ? 'Delivered'
                        : '';

    // Special handling for Unfulfilled and Refund cases
    if (element.orderStatus === 'Unfulfilled') {
      if (element.refundStatus === 'Refunded via Wallet') {
        element.trackingStatus = 'Refunded via Wallet';
        element.statusList = ['Order Placed', 'Accepted', 'Unfulfilled', 'Refund Initiated via Wallet', 'Refunded via Wallet'];
      } else if (element.refundStatus === 'Refunded via Gateway') {
        element.trackingStatus = 'Refunded via Gateway';
        element.statusList = ['Order Placed', 'Accepted', 'Unfulfilled', 'Refund Initiated via Gateway', 'Refunded via Gateway'];
      } else if (element.refundStatus === 'Refund Initiated via Wallet') {
        element.trackingStatus = 'Refund Initiated via Wallet';
        element.statusList = ['Order Placed', 'Accepted', 'Unfulfilled', 'Refund Initiated via Wallet', 'Refunded via Wallet'];
      } else if (element.refundStatus === 'Refund Initiated via Gateway') {
        element.trackingStatus = 'Refund Initiated via Gateway';
        element.statusList = ['Order Placed', 'Accepted', 'Unfulfilled', 'Refund Initiated via Gateway', 'Refunded via Gateway'];
      } else {
        element.trackingStatus = 'Order Unfulfilled';
        element.statusList = ['Order Placed', 'Accepted', 'Unfulfilled'];
      }
    } else {
      element.trackingStatus = status;

      if (!element.customerDeliveryDetails) {
        element.statusList = ['Order Placed', 'Accepted', 'In Process', 'Production Done', 'Delivered'];
      } else {
        switch (status) {
          case 'Order Cancelled':
            element.statusList = ['Order Placed', 'Order Cancelled', 'In Process', 'Production Done', 'Rider assigned', 'Out for Delivery', 'Delivered'];
            break;
          case 'Rescheduled':
            element.statusList = ['Order Placed', 'Accepted', 'In Process', 'Production Done', 'Rider assigned', 'Out for Delivery', 'Rescheduled', 'Delivered'];
            break;
          case 'Cancelled':
            element.statusList = ['Order Placed', 'Accepted', 'In Process', 'Production Done', 'Rider assigned', 'Out for Delivery', 'Cancelled', 'Delivered'];
            break;
          default:
            element.statusList = this.statusList; // Use default statusList
        }
      }
    }
  }

  generateInvoice(locationCode: number, invoiceNo: string, invoiceType: string) {
    var module = invoiceType;
    var invNo = invoiceNo;
    var locCode = locationCode;

    let dataToPrint: string[] = [];
    dataToPrint[0] = locationCode.toString();
    dataToPrint[1] = invoiceNo;
    dataToPrint[2] = invoiceType;
    // dataToPrint[3] = this.currentUrl;
    dataToPrint[3] = 'localhost'

    this.dialog.open(InvoicePreviewComponent, {
      height: "100%",
      data: dataToPrint,
    });
  }

  stepperStatus: { [orderNo: string]: number } = {};

  onStatusClick(element: WebOrderDto) {
    // Find the current step based on trackingStatus
    this.stepperStatus[element.orderNo] = element.statusList.findIndex(e => e === element.trackingStatus);
    let currentStep = this.stepperStatus[element.orderNo];

    setTimeout(() => {
      const stepper = document.getElementById("index_step_" + element.orderNo);
      if (!stepper) {
        console.error(`Stepper element with id "index_step_${element.orderNo}" not found.`);
        return;
      }

      const steps = stepper.getElementsByClassName("step");

      Array.from(steps).forEach((step, index) => {
        let stepNum = index;

        if (stepNum < currentStep) {
          this.addClass(step, "done");
          this.removeClass(step, "editing");
        } else if (stepNum === currentStep) {
          this.addClass(step, "done");
          this.addClass(step, "editing");
        } else {
          this.removeClass(step, "done");
          this.removeClass(step, "editing");
        }
      });
    }, 0);
  }

  hasClass(elem, className) {
    return new RegExp(" " + className + " ").test(" " + elem.className + " ");
  }

  addClass(elem, className) {
    if (!this.hasClass(elem, className)) {
      elem.className += " " + className;
    }
  }

  removeClass(elem, className) {
    var newClass = " " + elem.className.replace(/[\t\r\n]/g, " ") + " ";
    if (this.hasClass(elem, className)) {
      while (newClass.indexOf(" " + className + " ") >= 0) {
        newClass = newClass.replace(" " + className + " ", " ");
      }
      elem.className = newClass.replace(/^\s+|\s+$/g, "");
    }
  }

  selectedTab: { [key: number]: string | null } = {};
  toggleTab(index: number, tab: string) {
    this.selectedTab[index] = this.selectedTab[index] === tab ? null : tab;
    console.log(this.selectedTab[index]);
  }

  onDeliveryRateChange(webOrder: WebOrderDto) {
    if (!this.insertFeedBackDeliveryBoy && !webOrder.deliveryFeedBackWebDto?.isDeliveryFeedBackDone) {
      let deliveryBoyRating: DeliveryFeedBack = new DeliveryFeedBack();
      deliveryBoyRating.assignedNo = webOrder.assignShippingDto?.refNo;
      deliveryBoyRating.feedbackBy = webOrder.customer.refNo;
      deliveryBoyRating.feedbackDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      deliveryBoyRating.feedbackFor = "Delivery Boy";
      deliveryBoyRating.locationCode = webOrder.location?.refNo;
      deliveryBoyRating.toDeliveryBoy = this.deliveryRateValue.value;
      deliveryBoyRating.orderNo = webOrder.orderNo;

      console.log(deliveryBoyRating);


      this.insertFeedBackDeliveryBoy = this.invoiceHistoryService.insertFeedBack(this.apiFactory.insertFeedBack, [deliveryBoyRating])
        .subscribe((data: any) => {
          this.insertFeedBackDeliveryBoy = undefined;
          console.log(data);
          if (data != null) {
            this.isDeliveryFeedBackDone = true;
            webOrder.deliveryFeedBackWebDto.isDeliveryFeedBackDone = true;
            this.toastService.showSuccessToast("FeedBack Saved Sucessfully");
          }
        });
    }
  }

  onLocationRateChange(webOrder: WebOrderDto) {
    if (!this.insertFeedBackLocation && !webOrder.deliveryFeedBackWebDto?.isLocationFeedBackDone) {
      console.log(this.locationRateValue.value);
      let locationRating: DeliveryFeedBack = new DeliveryFeedBack();
      locationRating.assignedNo = webOrder.assignShippingDto?.refNo;
      locationRating.feedbackBy = webOrder.customer.refNo;
      locationRating.feedbackDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      locationRating.feedbackFor = "Location";
      locationRating.locationCode = webOrder.location?.refNo;
      locationRating.toLocation = this.locationRateValue.value;
      locationRating.orderNo = webOrder.orderNo;

      console.log(locationRating);

      this.insertFeedBackLocation = this.invoiceHistoryService.insertFeedBack(this.apiFactory.insertFeedBack, [locationRating])
        .subscribe((data: any) => {
          this.insertFeedBackLocation = undefined;
          console.log(data);
          if (data != null) {
            this.isLocationFeedBackDone = true;
            webOrder.deliveryFeedBackWebDto.isLocationFeedBackDone = true;
            this.toastService.showSuccessToast("FeedBack Saved Sucessfully");
          }
        });
    }
  }

  getProductNames(order: any): string {
    if (!order || !order.webOrderDetails) {
      return '';
    }
    return order.webOrderDetails.map((product: any) => product.productName).join(', ');
  }
}